<template>
  <div id="ModelCallSetting">
    <a-modal title="外呼设置" width="620px" :visible="this.$store.state.isShowCallSettingModel" @cancel="closeModel">
      <template slot="footer">
        <a-button key="back" @click="closeModel">不修改，关闭</a-button>
      </template>
      <table>
        <tr>
          <td style="width: 150px">当前接听的手机号：</td>
          <td>
            <a-input type="text" style="width: 250px; margin-right: 20px" id="telA" v-model="telA"></a-input>
            <a-button key="submit" type="primary" @click="submitChangeTelA" :disabled="submitTelAChangeBtnDisable"
              id="telASubmitBtn">
              确认修改
            </a-button>
          </td>
        </tr>
        <tr>
          <td style="width: 150px">绑定指定虚拟号：</td>
          <td>
            <a-input type="text" style="width: 250px; margin-right: 20px" id="telX" v-model="telX"></a-input>
            <a-button key="submit2" type="primary" @click="selectTelX" id="selectTelXSubmitBtn">
              确认绑定
            </a-button>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <a-divider />
          </td>
        </tr>
        <tr style="height: 50px">
          <td style="width: 150px">分配的外呼虚拟号：</td>
          <td>
            {{ phoneX }} | {{ phoneXArea }}
            <!--<a-button type="primary"
              >号码被标记，更换一个同地区的外呼号码</a-button
            >-->
          </td>
        </tr>
        <tr>
          <td>线路「1」（推荐）：</td>
          <td>
            <a-radio-group :defaultChecked="false" :disabled="areaRadioDisable3" :options="areaArr3"
              v-model="areaSelectValue3">
            </a-radio-group>
          </td>
        </tr>
        <tr>
          <td>线路「2」（2022-12-31关停）：</td>
          <td>
            <a-radio-group :defaultChecked="false" :disabled="areaRadioDisable" :options="areaArr"
              v-model="areaSelectValue" />
          </td>
        </tr>
        <tr>
          <td>线路「3」：</td>
          <td>
            <a-radio-group :defaultChecked="false" :disabled="areaRadioDisable2" :options="areaArr2"
              v-model="areaSelectValue2" />
          </td>
        </tr>
        <tr>
          <td>线路「4」：</td>
          <td>
            <a-radio-group :defaultChecked="false" :disabled="areaRadioDisable4" :options="areaArr4"
              v-model="areaSelectValue4" />
          </td>
        </tr>
      </table>

      <p style="color: red">
        注意事项：<br />
        1.点击对应地区就立即开始切换虚拟号码，若切换失败请刷新页面后重试。<br />
        2.更换外呼号码之后，之前的号码会被释放，家长无法回拨回来。<br />
        3.线路「4」应运营商要求，无法回电。
      </p>
    </a-modal>
  </div>
</template>

<script>
  import {
    GetCallSetting,
    ChangeCallTelA,
    SelectCallTelX,
    ChangeTelAWithArea
  } from "@/api/QkidsApi.js";
  import Message from "ant-design-vue/lib/message";
  const areaArr = [{ label: "自动选择地区", value: "auto" }];
  const areaArr2 = [{ label: "自动选择地区", value: "auto" }];
  var areaArr3 = [{ label: "自动选择地区", value: "auto" }];
  var areaArr4 = [{ label: "自动选择地区", value: "auto" }];

  export default {
    name: "ModelCallSetting",
    data: function () {
      return {
        initData: false,
        areaSelectValue: "auto",
        areaSelectValue2: "auto",
        areaSelectValue3: "auto",
        areaSelectValue4: "auto",
        areaArr,
        areaArr2,
        areaArr3,
        areaArr4,
        phoneX: "18600000001",
        phoneXArea: "",
        telA: "",
        telX: "",
        loading: true,
        submitTelAChangeBtnDisable: true,
        areaRadioDisable: false,
        areaRadioDisable2: false,
        areaRadioDisable3: false,
        areaRadioDisable4: false
      };
    },
    methods: {
      closeModel (e) {
        this.$store.state.isShowCallSettingModel = false;
      },
      selectTelX () {
        var telX = document.getElementById("telX").value;
        telX = telX.replace(/\s+/g, "");
        if (!/^1[13456789]\d{9}$/.test(telX)) {
          Message.error("手机号码填写有误，请重填");
        } else {
          SelectCallTelX(telX)
            .then(req => {
              if (req.status === 500) {
                Message.error(req.msg);
              } else if (req.status === 200) {
                Message.info("更换虚拟外显号码成功");
                this.phoneX = telX;
                this.phoneXArea = "手动指定外显";
              }
              console.log(req);
            })
            .catch(err => {
              console.log(err);
            });
        }
        console.log("submit tel B", this.telA);
      },
      submitChangeTelA () {
        var telA = document.getElementById("telA").value;
        telA = telA.replace(/\s+/g, "");
        if (!/^1[13456789]\d{9}$/.test(telA)) {
          Message.error("手机号码有误，请重填");
        } else {
          ChangeCallTelA(telA)
            .then(req => {
              if (req.status === 500) {
                Message.error(req.msg);
              } else if (req.status === 200) {
                Message.info("更换接听号码成功");
                this.submitTelAChangeBtnDisable = true;
              }
              console.log(req);
            })
            .catch(err => {
              console.log(err);
            });
        }
        console.log("submit tel B", this.telA);
      },
      getCallSettingNumbers () {
        GetCallSetting()
          .then(req => {
            if (req.status === 200) {
              this.initData = false;
              this.areaArr = [];
              this.areaArr2 = [];
              this.areaArr3 = [];
              this.areaArr4 = [];
              this.areaSelectValue = "";
              this.areaSelectValue2 = "";
              this.areaSelectValue3 = "";
              this.areaSelectValue4 = "";

              // 设置选中状态
              if (req.data.personNumbers.type === "AX") {
                this.areaSelectValue = req.data.personNumbers.areacode;
              } else if (req.data.personNumbers.type === "YAXB") {
                this.areaSelectValue2 = req.data.personNumbers.areacode;
              } else if (
                req.data.personNumbers.type === "COP" ||
                req.data.personNumbers.type === "ELINK"
              ) {
                this.areaSelectValue3 = req.data.personNumbers.areacode;
              } else if (req.data.personNumbers.type === "YX") {
                this.areaSelectValue4 = req.data.personNumbers.areacode;
              }
              this.phoneX = req.data.personNumbers.phone;
              this.phoneXArea = req.data.personNumbers.area;
              this.telA = req.data.person.phone;
              if (req.data.citys != null) {
                req.data.citys.forEach(item => {
                  if (item.Countarea - item.Countused > 0) {
                    this.areaArr.push({
                      label:
                        item.Area +
                        "(可用:" +
                        (item.Countarea - item.Countused) +
                        "个" +
                        ")",
                      value: item.Areacode
                    });
                  }
                });
              }
              if (req.data.yaxbcitys != null) {
                req.data.yaxbcitys.forEach(item => {
                  if (item.Countarea - item.Countused > 0) {
                    this.areaArr2.push({
                      label:
                        item.Area +
                        "(可用:" +
                        (item.Countarea - item.Countused) +
                        "个" +
                        ")",
                      value: item.Areacode
                    });
                  }
                });
              }

              req.data.copcitys.forEach(item => {
                this.areaArr3.push({ label: item.Area, value: item.Areacode });
                // this.areaArr3.push({ label: "ELINK 移动号码池", value: "ELINK" });
              });
              if (req.data.yxcitys != null) {
                req.data.yxcitys.forEach(item => {
                  if (item.Countarea - item.Countused > 0) {
                    this.areaArr4.push({
                      label:
                        item.Area +
                        "(可用:" +
                        (item.Countarea - item.Countused) +
                        "个" +
                        ")",
                      value: item.Areacode
                    });
                  }
                });
              }

              console.log("req.data.person.phone:", req.data.person.phone);
              if (req.data.person.phone === "" || req.data.person.phonex === "") {
                this.$store.state.isShowCallSettingModel = true;
                alert("新用户，请先在外呼设置里设置接听号码与选择外呼虚拟号地区");
              }
              setTimeout(() => {
                // 延迟确认状态，防止 UI 刷新数据错误
                this.initData = true;
                this.submitTelAChangeBtnDisable = true;
              }, 1000);
            } else {
              Message.error("请求错误,请重新登陆");
              this.$router.push("/");
            }
            console.log(req);
          })
          .catch(err => {
            console.log(err);
          });
      },
      submitChangeTelX (areacode, type) {
        console.log("submitChangeTelX", areacode, type, this.initData);
        if (this.initData) {
          this.areaRadioDisable = true;
          this.areaRadioDisable2 = true;
          this.areaRadioDisable3 = true;
          this.areaRadioDisable4 = true;
          this.phoneX = "重新分配号码中，大约需要 2~10 秒，请勿刷新";
          let oldPhoneX = this.phoneX;
          ChangeTelAWithArea(areacode, type)
            .then(req => {
              console.log("req：" + req);
              if (req.status === 200) {
                Message.info("更换绑定成功");
                this.phoneX = req.newphone;
                this.areaRadioDisable = false;
                this.areaRadioDisable2 = false;
                this.areaRadioDisable3 = false;
                this.areaRadioDisable4 = false;
                this.getCallSettingNumbers();
              } else if (req.status === 201) {
                Message.error(req.msg);
                Message.error("请刷新页面后更换其他城市");
              } else {
                this.areaRadioDisable = false;
                this.areaRadioDisable2 = false;
                this.areaRadioDisable3 = false;
                this.areaRadioDisable4 = false;
                this.phoneX = oldPhoneX;
                Message.error("更换绑定失败，稍后重试");
              }
            })
            .catch(err => {
              console.log("err:" + err);
            });
        }
      }
    },
    watch: {
      telA: function (e) {
        console.log("telA:", e, this.initData);
        if (this.initData) {
          this.submitTelAChangeBtnDisable = false;
        }
      },
      areaSelectValue: function (v) {
        this.submitChangeTelX(v, "AX");
      },
      areaSelectValue2: function (v) {
        this.submitChangeTelX(v, "YAXB");
      },
      areaSelectValue3: function (v) {
        this.submitChangeTelX(v, v == "ELINK" ? "ELINK" : "COP");
      },
      areaSelectValue4: function (v) {
        this.submitChangeTelX(v, "YX");
      }
    },
    created: function () {
      console.log("mounted");
      this.getCallSettingNumbers();
    }
  };
</script>

<style scoped></style>